import React from 'react';
import ServicePage from '../../components/site/ServicePage';
import { REVIEW_FAQS as FAQS } from '../../site/faqs';

export default function Reviews() {
  return (
    <ServicePage
      path="/reviews"
      eyebrow="Review automation"
      title="Ask on the day the order completes."
      lead="When the last piece is delivered, a short, polite survey goes out in the same text thread. Feedback reaches your team, and every customer is invited to review you on Google."
      features={[
        { title: 'Timed to the delivery', text: 'The request goes out the day the last piece is delivered.' },
        { title: 'Feedback first', text: 'Problems reach your team the same hour, with the order attached.' },
        { title: 'One tap to Google', text: 'Every customer gets the same soft prompt and the same review link.' },
        { title: 'Seen in the dashboard', text: 'Every response, next to the receipt it belongs to.' },
        { title: 'Follows the guidelines', text: 'One survey per completed order. No lists, no blasts.' },
      ]}
      customer={{
        title: 'What your customer gets',
        items: [
          { title: 'Asked once, politely', text: 'A short question after the delivery, in a thread they know.' },
          { title: 'Heard when something is wrong', text: 'Their feedback goes straight to the store.' },
          { title: 'An easy way to say thanks', text: 'One tap to leave the review.' },
        ],
      }}
      steps={[
        { title: 'Included with the digital receipt', text: 'Nothing to install.' },
        { title: 'You set the wording and the link', text: 'Your Google listing, your tone.' },
        { title: 'Reviews start the week deliveries finish', text: 'Read them in the dashboard.' },
      ]}
      faqs={FAQS}
      closing={{ title: 'See the survey and the dashboard.', text: 'Book a 30 minute demo.' }}
    />
  );
}
